export default __webpack_public_path__ + "static/media/exam_edition_1.e8595186.jpg";